import { navigate } from "../lib/router";

const ITEMS: Array<{ section?: string; label?: string; icon?: string; to?: string; match?: string }> = [
  { label: "Головна", icon: "⌂", to: "/", match: "/" },
  { section: "Робота" },
  { label: "Проєкти", icon: "▦", to: "/projects", match: "/projects" },
  { label: "Бренд-кіти", icon: "✦", to: "/brand-kits", match: "/brand-kits" },
  { section: "Workspace" },
  { label: "Експорти", icon: "⤓", to: "/exports", match: "/exports" },
  { label: "Архів", icon: "▤", to: "/archived", match: "/archived" },
  { label: "Налаштування", icon: "⚙", to: "/settings", match: "/settings" },
];

export default function SidebarNav({ activePrefix }: { activePrefix: string }) {
  return (
    <aside className="sidebar">
      <div className="brand">
        <div className="logo">K</div>
        <div>
          <div className="name">Kidden Studio</div>
          <div className="sub">Video creative tool</div>
        </div>
      </div>
      {ITEMS.map((it, i) =>
        it.section ? (
          <div className="nav-section" key={i}>
            {it.section}
          </div>
        ) : (
          <div
            key={i}
            className={"nav-item" + (isActive(it.match!, activePrefix) ? " active" : "")}
            onClick={() => navigate(it.to!)}
          >
            <span className="ico">{it.icon}</span>
            {it.label}
          </div>
        ),
      )}
      <div className="nav-spacer" />
      <div
        className="btn primary"
        style={{ width: "100%" }}
        onClick={() => navigate("/projects/new")}
      >
        + Новий проєкт
      </div>
    </aside>
  );
}

function isActive(match: string, active: string): boolean {
  if (match === "/") return active === "/";
  return active === match || active.startsWith(match + "/");
}
